<ng-template #typeTmpl let-item="item">
    @if (printing) {
    <div class="whitespace-nowrap text-xs text-gray-900">

        @if (!docType) {
        <span class="inline-block w-24 text-left text-gray-400 uppercase tracking-wide">{{ item.type }}</span>
        }

        <span class="font-semibold">{{ item.id_by_company }}</span>

        @if (item.type === 'factura') {
        <span class="ml-2 text-xs font-medium" [class.text-blue-700]="hasAlbaranRelation(item)"
            [class.text-slate-500]="!hasAlbaranRelation(item)">({{ hasAlbaranRelation(item) ? 'CRE' : 'CONT' }})</span>
        }

        @if (item.status === 'draft') {
        <span class="ml-2 text-amber-700 text-xs font-medium">(Borrador)</span>
        }

    </div>
    } @else {
    <div class="flex flex-col items-start gap-0.5 leading-tight">
        @if (!docType) {
        <span class="text-xs text-gray-400 uppercase tracking-wide">{{ item.type }}</span>
        }
        <span class="flex items-center gap-1">
            @if (item.verifactu_status === 'sent') {
            <span class="flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500"
                aria-label="Enviado a Verifactu">
                <svg class="h-2.5 w-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke-width="3"
                    stroke="currentColor">
                    <title>Enviado a Verifactu</title>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
            </span>
            }
            <span class="font-bold text-sm text-gray-900">{{ item.id_by_company }}</span>
            @if (item.type === 'factura') {
            <span
                class="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                [class.bg-blue-100]="hasAlbaranRelation(item)" [class.text-blue-700]="hasAlbaranRelation(item)"
                [class.bg-slate-100]="!hasAlbaranRelation(item)" [class.text-slate-600]="!hasAlbaranRelation(item)"
                [title]="hasAlbaranRelation(item) ? 'Factura de crédito (con albaranes asociados)' : 'Factura al contado (sin albaranes asociados)'">
                {{ hasAlbaranRelation(item) ? 'CRE' : 'CONT' }}
            </span>
            }
        </span>
        @if (item.status === 'draft') {
        <span
            class="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-800">
            <span class="h-1.5 w-1.5 rounded-full bg-amber-500"></span>
            Borrador
        </span>
        }
    </div>
    }
</ng-template>

<ng-template #totalTmpl let-item="item">
    @if (printing) {
    <div class="whitespace-nowrap text-xs text-gray-900">
        <span class="font-semibold" [centToEurDisplay]="item.total"></span>
        <span class="ml-2 text-gray-400 text-xs">(<span [centToEurDisplay]="item.subtotal"></span> sin
            IVA)</span>
    </div>
    } @else {
    <div class="flex flex-col items-start gap-0.5 leading-tight">
        <span class="font-bold text-sm text-gray-900" [centToEurDisplay]="item.total"></span>
        <span class="text-xs text-gray-400"><span [centToEurDisplay]="item.subtotal"></span> sin IVA</span>
    </div>
    }
</ng-template>

<ng-template #relationTmpl let-item="item" let-header="header">
    <document-relation-chips [relations]="item[header.key]" [linkFor]="relationLink"></document-relation-chips>
</ng-template>
